import React from 'react'
import ReactDOM from 'react-dom/client'
import '@/index.css'

// Determine which app to load based on BUILD_TARGET
const BUILD_TARGET = import.meta.env.MODE

async function loadApp() {
  let AppComponent

  switch (BUILD_TARGET) {
    case 'admin':
      const adminModule = await import('./apps/admin/App')
      AppComponent = adminModule.App
      break
    case 'customer':
      const customerModule = await import('./apps/customer/App')
      AppComponent = customerModule.App
      break
    case 'partner':
      const partnerModule = await import('./apps/partner/App')
      AppComponent = partnerModule.App
      break
    default:
      const defaultModule = await import('./apps/admin/App')
      AppComponent = defaultModule.App
  }

  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <AppComponent />
    </React.StrictMode>
  )
}

loadApp()

